import React, { FC } from "react";
import { Id } from "../../../types";
import { useMachine } from "@xstate/react";
import { fetchMachine } from "../../../machines/fetch";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { activeSubscriptionIdState, rolesState } from "../../../atoms";
import { Button, useToast } from "@chakra-ui/react";
import { deleteRole } from "3.0/api/delete-role";

type Props = {
  id: Id;
  onSuccess: () => void;
};

export const DeleteRole: FC<Props> = (props) => {
  const { id, onSuccess } = props;

  const toast = useToast();

  const activeSubscriptionId = useRecoilValue(activeSubscriptionIdState);
  const setRoles = useSetRecoilState(rolesState);

  const [state, send] = useMachine(fetchMachine, {
    services: {
      fetch: () =>
        deleteRole({ id, subscriptionId: activeSubscriptionId as Id }),
    },

    actions: {
      success: (_, event: any) => {
        setRoles(event.data.roles);
        onSuccess();
        toast({
          title: "rol verwijderd",
          status: "success",
          isClosable: true,
        });
      },

      failure: (_, event: any) => {
        toast({
          title: "verwijderen van rol niet gelukt",
          description: JSON.stringify(event.data, null, 2),
          status: "error",
          isClosable: true,
        });
      },
    },
  });

  return (
    <Button
      type="submit"
      size="sm"
      isLoading={state.matches("loading")}
      onClick={() => {
        send(state.matches("failure") ? "RETRY" : "FETCH");
      }}
    >
      bevestig
    </Button>
  );
};
